import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { getAllAnswers, saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'children'

const answers: AnswerType[] = [
  {
    emoji: '🚫',
    title: 'pages.onboarding.children.options.noNotPlanning',
    value: 'no-not-planning',
  },
  {
    emoji: '⏳',
    title: 'pages.onboarding.children.options.noButPlanning',
    value: 'not-yet-but-planning',
  },
  {
    emoji: '🏡',
    title: 'pages.onboarding.children.options.yesLivingAtHome',
    value: 'yes-living-at-home',
  },
  {
    emoji: '🎓',
    title: 'pages.onboarding.children.options.yesNotLivingAtHome',
    value: 'yes-not-living-at-home',
  },
]

export default function ChildrenPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && answers.some((answer) => answer.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const value = input.value

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Do you have children?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)

      if (window.ReactNativeWebView) {
        const allAnswers = getAllAnswers()
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'ONBOARDING_COMPLETE',
            onboardingAnswers: allAnswers,
          }),
        )
      }
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.children.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
